import { os } from '../../utils/environment';

export default function getCmdOrCtrl() {
  return os.name.includes('Mac') ? 'cmd' : 'ctrl';
}
